import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { formEditJirafieldsResource } from '@jira/router-resources__service-desk-customer-service-forms/src/useFormEditJirafields.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { formEditProformaFormResource } from '@jira/router-resources__customer-service-common/src/formEditProformaFormResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsFormEditRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsFormEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingFormEditAppPageEntryPoint } from './ui/form-edit/index.tsx';

export const helpCenterSettingsFormEditRouteEntry: Route = createEntry(
	helpCenterSettingsFormEditRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.form-edit',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () => helpCenterSettingFormEditAppPageEntryPoint,
		resources: [
			...getServiceDeskSettingsResources(),
			formEditJirafieldsResource,
			customerExperiencesNavigationResource,
			resourceWithCondition(() => fg('csm_conditional_form_fields'), formEditProformaFormResource),
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
